// src/components/Header.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import MiniCartModal from "./MiniCartModal";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { cartCount } = useCart(); // usamos cartCount del contexto

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className="w-full border-b border-gray-200 bg-white">
      <div className="max-w-[1200px] mx-auto flex flex-wrap items-center justify-between px-5 py-4">
        {/* Logo */}
        <div className="flex items-center gap-3">
          <div className="w-10 h-10">
            <svg
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.8261 30.5736C16.7203 29.8826 20.2244 29.4783 24 29.4783C27.7756 29.4783 31.2797 29.8826 34.1739 30.5736C36.9144 31.2278 39.9967 32.7669 41.3563 33.8352L24.8486 7.36089C24.4571 6.73303 23.5429 6.73303 23.1514 7.36089L6.64374 33.8352C8.00331 32.7669 11.0856 31.2278 13.8261 30.5736Z"
                fill="currentColor"
              ></path>
            </svg>
          </div>
          <h2 className="text-gray-900 text-lg font-bold">Fashion Hub</h2>
        </div>

        {/* Enlaces menú desktop */}
        <nav className="hidden md:flex items-center gap-6 text-gray-900 font-medium">
          <Link to="/">Novedades</Link>
          <Link to="/hombres">Hombres</Link>
          <Link to="/mujeres">Mujeres</Link>
          <Link to="/accesorios">Accesorios</Link>
          <Link to="/ofertas">Ofertas</Link>
        </nav>

        {/* Sección derecha */}
        <div className="flex items-center gap-3 mt-3 md:mt-0">
          {/* Iniciar sesión */}
          <Link
            to="/login"
            className="text-gray-900 font-medium px-3 py-2 rounded-lg hover:bg-gray-100 transition"
          >
            Iniciar sesión
          </Link>

          {/* Mis Compras */}
          <Link
            to="/mis-compras"
            className="text-gray-900 font-medium px-3 py-2 rounded-lg hover:bg-gray-100 transition"
          >
            Mis Compras
          </Link>

          {/* Favoritos */}
          <Link
            to="/favoritos"
            className="flex items-center justify-center h-10 w-10 bg-gray-100 rounded-lg hover:bg-gray-200 transition"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className="w-5 h-5 text-gray-700"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4.318 6.318a4.5 4.5 0 016.364 0L12 7.636l1.318-1.318a4.5 4.5 0 116.364 6.364L12 21.364l-7.682-7.682a4.5 4.5 0 010-6.364z"
              />
            </svg>
          </Link>

          {/* Carrito */}
          <div className="relative">
            <Link
              to="/carrito"
              className="flex items-center justify-center h-10 w-10 bg-gray-100 rounded-lg hover:bg-gray-200 transition"
            >
              <i className="fas fa-shopping-cart text-gray-700"></i>
            </Link>
            {cartCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-600 text-white text-xs font-bold px-2 py-0.5 rounded-full">
                {cartCount}
              </span>
            )}
          </div>

          {/* Avatar usuario */}
          <div
            className="w-10 h-10 rounded-full bg-cover bg-center"
            style={{
              backgroundImage:
                'url("https://lh3.googleusercontent.com/aida-public/...")',
            }}
          ></div>
        </div>

        {/* Botón menú móvil */}
        <div className="md:hidden ml-auto">
          <button onClick={toggleMenu} className="p-2 bg-gray-100 rounded-lg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className="w-6 h-6 text-gray-700"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
        </div>
      </div>

      {/* Modal menú móvil */}
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-start pt-20">
          <div className="bg-white w-3/4 max-w-sm rounded-lg p-6 flex flex-col gap-4">
            <Link
              to="/"
              className="text-gray-900 font-medium hover:underline"
              onClick={toggleMenu}
            >
              Novedades
            </Link>
            <Link
              to="/hombres"
              className="text-gray-900 font-medium hover:underline"
              onClick={toggleMenu}
            >
              Hombres
            </Link>
            <Link
              to="/mujeres"
              className="text-gray-900 font-medium hover:underline"
              onClick={toggleMenu}
            >
              Mujeres
            </Link>
            <Link
              to="/accesorios"
              className="text-gray-900 font-medium hover:underline"
              onClick={toggleMenu}
            >
              Accesorios
            </Link>
            <Link
              to="/ofertas"
              className="text-gray-900 font-medium hover:underline"
              onClick={toggleMenu}
            >
              Ofertas
            </Link>
            <button
              onClick={toggleMenu}
              className="mt-4 py-2 bg-gray-700 text-white rounded-lg"
            >
              Cerrar
            </button>
          </div>
        </div>
      )}

      {/* MiniCart */}
      <MiniCartModal />
    </header>
  );
};

export default Header;
